var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.665 20l-.029-9.09H0V7.272h3.636V5c0-3.374 2.09-5 5.1-5 1.441 0 2.68.107 3.042.155v3.526l-2.088.001c-1.637 0-1.954.778-1.954 1.92v1.67H12.5l-1.818 3.637H7.736V20H3.665z",
    fill: "#0F0"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMyAyMCI+PHBhdGggZD0iTTMuNjY1IDIwbC0uMDI5LTkuMDlIMFY3LjI3MmgzLjYzNlY1YzAtMy4zNzQgMi4wOS01IDUuMS01IDEuNDQxIDAgMi42OC4xMDcgMy4wNDIuMTU1djMuNTI2bC0yLjA4OC4wMDFjLTEuNjM3IDAtMS45NTQuNzc4LTEuOTU0IDEuOTJ2MS42N0gxMi41bC0xLjgxOCAzLjYzN0g3LjczNlYyMEgzLjY2NXoiIGZpbGw9IiMwRjAiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvc3ZnPg==";
export { SvgFacebook as ReactComponent };